import React from 'react';
import { useSelector } from 'react-redux';
import Divider from 'housecall-ui/dist/DesignSystem/DataDisplay/Divider/Divider';
import Box from 'housecall-ui/dist/DesignSystem/Layout/Box/Box';

import AuthorizationService from 'components/AdminNew/Models/AuthorizationService';
import { FEATURE_PROFIT_RHINO } from 'components/PayWall/Redux/Actions';
import { PayWallFullState } from 'components/PayWall/Redux/Reducer.type';

import AddFeatureRow from './AddFeatureRow';
import { Feature, OnFeatureToggle } from './types';

type Props = {
  features: Feature[];
  onFeatureToggle: OnFeatureToggle;
};

export default function AddFeatures(props: Props) {
  const { features, onFeatureToggle } = props;
  const employee = useSelector((state: PayWallFullState) => state.employee);
  const isAdminUser = AuthorizationService.isAdminUser(employee);

  if (features.length === 0) {
    return null;
  }

  const rows: React.ReactNode[] = [];

  features.forEach((feature) => {
    if (!feature.displayName) {
      return;
    }

    if ([FEATURE_PROFIT_RHINO].includes(feature.featureName)) {
      // If feature is not allowed but already added, we should still show it so that user can remove it
      if (!isAdminUser && !feature.enabled) {
        return;
      }
    }

    rows.push(
      <React.Fragment key={`feature_${feature.displayName}`}>
        <AddFeatureRow key={feature.featureName} feature={feature} onFeatureToggle={onFeatureToggle} />
        <Box my={2}>
          <Divider />
        </Box>
      </React.Fragment>
    );
  });

  return <>{rows}</>;
}
